import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CODE_STATUS } from '@app/constant/CodeConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import getParameters from '@app/libs/getParameters'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

export default function TransactionReport({ transaction, total, campaignSearchList }) {
  const { t, i18n } = useTranslation()
  const { url } = usePage()
  const urlObj = new URL(url, location.origin)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'voucher_name',
              Header: t('TRANSACTION_REPORT.VOUCHER_NAME'),
              accessor: 'voucher_name',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'campaign_name',
              Header: t('TRANSACTION_REPORT.CAMPAIGN_NAME'),
              accessor: 'campaign_name',
              options: campaignSearchList.map((item) => ({ id: item.id, name: item.name })),
              type: 'multiSelect',
              router: 'partner.report.transaction',
              only: 'campaignSearchList',
            },
            {
              id: 'updated_at',
              Header: t('TRANSACTION_REPORT.TIME'),
              accessor: 'updated_at',
              type: 'dateRange',
            },
            {
              id: 'customer_id',
              Header: t('TRANSACTION_REPORT.CUSTOMER_ID'),
              accessor: 'customer_id',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'type',
              Header: t('TRANSACTION_REPORT.TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
              disableFilters: true,
            },
            {
              id: 'status',
              Header: t('TRANSACTION_REPORT.STATUS'),
              accessor: ({ status }) => t(`CODES.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: CODE_STATUS.REDEEMED, name: t('STATUS.REDEEMED') },
                { value: CODE_STATUS.USED, name: t('STATUS.USED') },
              ],
            },
            {
              id: 'price',
              Header: t('TRANSACTION_REPORT.PRICE'),
              accessor: 'price',
              type: 'number',
              disableFilters: true,
            },
          ]}
          data={transaction}
          enableCollapseFilter={false}
          exportable={{
            enableExport: true,
            url: 'partner.report.transaction.export',
            params: { ...getParameters(urlObj), locale: i18n.language },
          }}
          routeName="partner.report.transaction"
          total={total}
        />
      </Grid>
    </Grid>
  )
}
